/*
  Stack the Shopify Forms "15% off" teaser above Smile's launcher (both bottom-left).
  The teaser renders inside <shopify-forms-embed>'s open shadow root, which theme CSS
  can't style, so set its offset through the CSSOM (allowed under the store's CSP,
  unlike an injected <style>). Only the collapsed teaser moves; the full pop-up doesn't.
*/
(() => {
  const OFFSET = '72px';

  const adjust = (root) => {
    const el = root.getElementById('app-embed');
    if (!el) return;
    const isTeaser = /appEmbedRootTeaser/.test(el.className) && /appEmbedBottomLeft/.test(el.className);
    if (isTeaser) el.style.setProperty('bottom', OFFSET, 'important');
    else el.style.removeProperty('bottom');
  };

  const watch = (host) => {
    if (host.dataset.launcherWatched || !host.shadowRoot) return;
    host.dataset.launcherWatched = '1';
    adjust(host.shadowRoot);
    new MutationObserver(() => adjust(host.shadowRoot)).observe(host.shadowRoot, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  const scan = () => document.querySelectorAll('shopify-forms-embed').forEach(watch);
  scan();
  // The shadow root can attach after the host is inserted, which the observer below
  // can't see, so re-check for the first ten seconds.
  let tries = 0;
  const timer = setInterval(() => { scan(); if (++tries >= 20) clearInterval(timer); }, 500);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
